import { MenuItemAggregate } from '../../../../../aggregats/menu/menu-item.aggregate';
import {
  dossiersFinancementSousMenuItem,
  exportComptableSousMenuItem,
  facturationSousMenuItemSuivi,
  facturationSousMenuItemTraitement,
} from './sous-menu-items.constantes';

export const financierMenuItem: MenuItemAggregate = new MenuItemAggregate('icon-pie-chart', 'Financier', [
  dossiersFinancementSousMenuItem,
  facturationSousMenuItemTraitement,
  facturationSousMenuItemSuivi,
  exportComptableSousMenuItem,
]);
